import axios, {
  // AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

// app
import app from "../config/app";
// import { guest_path } from "../service/validate/guestpath";

const guest_routes = [
  "/login",
  "/register",
  "/training",
  "/forgot-password",
  "/blogs",
  "/about-us",
  "/prompt",
  "/trainings",
  "/services",
  "/contact-us",
  "/terms-and-condition",
  "/faqs",
  "/privacy-policy",
  "/",
];

const check_protected_routes = (pathname: string): boolean => {
  if (guest_routes.includes(pathname)) return false;
  // eslint-disable-next-line no-useless-escape
  const blog_route_regex = /^\/blog\/(?:[a-fA-F0-9\-]{36}|\d+)$/;
  if (blog_route_regex.test(pathname)) return false;
  return true;
};

const createApiInstance = (baseURL?: string) => {
  const instance = axios.create({ baseURL });

  instance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem("@serial");

      if (config.headers) {
        if (token) config.headers.Authorization = `Bearer ${token}`;

        config.headers.Accept = "application/json";
        if (config.data instanceof FormData) {
          config.headers.delete("Content-Type");
        } else {
          config.headers["Content-Type"] = "application/json";
        }
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
      if (
        error.response?.status === 401 &&
        check_protected_routes(window.location.pathname)
      ) {
        window.location.href = "/login";
      }

      return Promise.reject(error);
    },
  );

  return instance;
};

const axiosInstance = createApiInstance(app.baseURL);
export const rootApiInstance = createApiInstance(app.baseURL);

export default axiosInstance;
